import React from 'react';

export function LossCarousel({ metrics, renderCard }) {
    const [index, setIndex] = React.useState(0);
    const [hovered, setHovered] = React.useState(false);
    const [focused, setFocused] = React.useState(false);
    const [hidden, setHidden] = React.useState(document.hidden);
    const count = metrics.length;
    const active = count ? index % count : 0;

    React.useEffect(() => {
        const onVisibility = () => setHidden(document.hidden);
        document.addEventListener('visibilitychange', onVisibility);
        return () => document.removeEventListener('visibilitychange', onVisibility);
    }, []);
    React.useEffect(() => {
        if (count < 2 || hovered || focused || hidden) return;
        const timer = window.setInterval(() => setIndex(current => (current + 1) % count), 5000);
        return () => window.clearInterval(timer);
    }, [count, hovered, focused, hidden, active]);

    if (!count) return null;
    return (
        <section className="floor-deck__loss-carousel" aria-label="Availability and losses" aria-roledescription="carousel"
            onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
            onFocus={() => setFocused(true)}
            onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setFocused(false); }}>
            <div className="floor-deck__carousel-viewport">
                <div className="floor-deck__carousel-track" style={{ transform: `translateX(-${active * 100}%)` }}>
                    {metrics.map((metric, position) => (
                        <div key={metric.title} className="floor-deck__carousel-slide"
                            role="group" aria-roledescription="slide" aria-label={`${position + 1} of ${count}`}
                            aria-hidden={position !== active} inert={position !== active ? '' : undefined}>
                            {renderCard(metric, position)}
                        </div>
                    ))}
                </div>
            </div>
            {count > 1 && <div className="floor-deck__carousel-controls">
                <button type="button" className="floor-deck__carousel-arrow" aria-label="Previous card"
                    onClick={() => setIndex((active + count - 1) % count)}><span aria-hidden="true">‹</span></button>
                {metrics.map((metric, position) => (
                    <button key={metric.title} type="button" className="floor-deck__carousel-dot"
                        aria-label={`Show ${metric.title}`} aria-pressed={position === active}
                        onClick={() => setIndex(position)}><span /></button>
                ))}
                <button type="button" className="floor-deck__carousel-arrow" aria-label="Next card"
                    onClick={() => setIndex((active + 1) % count)}><span aria-hidden="true">›</span></button>
            </div>}
        </section>
    );
}
